module.exports = __webpack_public_path__ + "img/regular_loan_overview_icon02.43ccd525.svg";